import React from 'react';
import { Card } from 'react-bootstrap';
import Button from 'components/DesignSystem/Button';
import useOverviewOptions from 'hooks/Meteorology/Weather/Overview/useOverviewOptions';
import useStatusPeriodSelection from 'hooks/Meteorology/Weather/Area/Status/useStatusPeriodSelection';
import useAreaStatusImage from 'hooks/Meteorology/Weather/Area/Status/useAreaStatusImage';
import useStatusImageDownload from 'hooks/Meteorology/Weather/Area/Status/useStatusImageDownload';
import EnlargeableImage from 'components/Meteorology/Fields/SynopticCharts/SynopticChart/Map/EnlargeableImage';
import CentralizedSpinner from 'components/CentralizedSpinner';
import Selector from 'components/DesignSystem/Selector';
import useIsMobile from 'utils/hooks/useIsMobile';
import StatusCard from 'components/Meteorology/Weather/Area/Status/Mobile/StatusCard';

export default function CurrentPanel({ area }: { area: string }) {
  const isMobile = useIsMobile();
  const { overviewOptions: periods, isLoading: periodsLoading } = useOverviewOptions();
  const {
    statusImageBase64,
    statusImageLoading,
    setImage,
    triggerStatus,
  } = useAreaStatusImage();
  const {
    period,
    onPeriodChange,
  } = useStatusPeriodSelection({
    area,
    setImage,
    triggerStatus,
  });
  const {
    onStatusDownloadClick,
    downloadDisabled,
  } = useStatusImageDownload(statusImageBase64, statusImageLoading, area);

  const periodSelector = (
    <Selector
      id="statusPeriodSelect"
      placeholder="Período"
      value={period}
      setValue={onPeriodChange}
      containerClassName={isMobile ? 'flex-grow-1' : 'flex-grow-1 me-2'}
    >
      {(periods || []).map(({ value, label }) => (
        <option key={value} value={value}>{label}</option>
      ))}
    </Selector>
  );

  const downloadButton = (
    <Button
      id="currentImageDownloadButton"
      small
      className={`icon-button weather-download-button${isMobile ? '' : ' ms-lg-3'}`}
      onClick={onStatusDownloadClick}
      disabled={downloadDisabled}
      icon="download"
    />
  );

  const image = !statusImageLoading && statusImageBase64 && (
    <EnlargeableImage src={`data:image/png;base64,${statusImageBase64}`} className="mt-3" />
  );

  if (isMobile) {
    return (
      <StatusCard title="OBSERVADO">
        {periodsLoading ? <CentralizedSpinner /> : (
          <>
            <div className="status-controls-mobile">
              {periodSelector}
              {downloadButton}
            </div>
            {statusImageLoading && <CentralizedSpinner />}
            {image}
          </>
        )}
      </StatusCard>
    );
  }

  return (
    <Card className="shadow-sm forecast-instruction-card h-100">
      <Card.Header>
        OBSERVADO
      </Card.Header>
      <Card.Body>
        {periodsLoading ? <CentralizedSpinner /> : (
          <>
            <div className="d-lg-flex mt-3 mx-3 align-items-center">
              {periodSelector}
              {downloadButton}
            </div>
            {statusImageLoading && <CentralizedSpinner />}
            {image}
          </>
        )}
      </Card.Body>
    </Card>
  );
}
